import httpService from "./httpService";
import cookie from "js-cookie";

export const userService = {
  login,
  logout,
  signup,
  query,
  getById,
  getAdmin,
  remove,
  save,
  sendPassword,
  sendCheckMail,
  keepMaftir,
  addMaftir,
  sendMaftir,
  updateMaftir,
  removeMaftir,
  keepParasha,
  sendParasha,
  updateParasha,
  removeParasha,
  keepMaftirH,
  sendMaftirH,
  updateMaftirH,
  removeMaftirH,
  keepParashaH,
  sendParashaH,
  updateParashaH,
  removeParashaH,
  keepKiddush,
  sendKiddush,
  updateKiddush,
  removeKiddush,
  keepShlishit,
  sendShlishit,
  updateShlishit,
  removeShlishit,
  keepEvennement,
  sendEvennement,
  updateEvennement,
  removeEvennement,
  keepDecaissement,
  sendDecaissement,
  updateDecaissement,
  removeDecaissement,
  sendEmail,
  changePassword,
  keepInfHome,
};

function query(filterBy = {}) {
  let queryStr = "?";
  for (const key in filterBy) {
    queryStr += `${key}=${filterBy[key]}&`;
  }
  //  console.log(queryStr);
  return httpService.get(`user${queryStr || ""}`);
}

function getById(userId) {
  return httpService.get(`user/${userId}`);
}
function getAdmin() {
  return httpService.get(`user/getAdmin`);
}
function remove(userId) {
  return httpService.delete(`user/${userId}`);
}

async function save(user) {
  if (user._id) {
    return httpService.put(`user/${user._id}`, user);
  } else {
    return httpService.post(`user`, user);
  }
}

async function login(userCred) {
  const user = await httpService.post("auth/login", userCred);
  return _handleLogin(user);
}
async function sendPassword(userCred) {
  const user = await httpService.post("auth/sendpassword", userCred);
  return user;
}
async function sendEmail(userCred) {
  //console.log("usercred", userCred);
  const user = await httpService.post("user/sendemail", userCred);
  return user;
}

async function sendCheckMail(userCred) {
  const user = await httpService.post("auth/sendcheckmail", userCred);
  return user;
}
async function keepShlishit() {
  const shlishit = await httpService.get("shlishit");
  return shlishit;
}

async function sendShlishit(data) {
  const shlishit = await httpService.post("shlishit", data);
  return shlishit;
}

async function updateShlishit(data) {
  const shlishit = await httpService.put(`shlishit/${data._id}`, data);
  return shlishit;
}

async function removeShlishit(shlishitId) {
  const res = await httpService.delete(`shlishit/${shlishitId}`);
  return res;
}
async function keepKiddush() {
  const kiddush = await httpService.get("kiddush");
  return kiddush;
}

async function sendKiddush(data) {
  const kiddush = await httpService.post("kiddush", data);
  return kiddush;
}

async function updateKiddush(data) {
  const kiddush = await httpService.put(`kiddush/${data._id}`, data);
  return kiddush;
}

async function removeKiddush(kiddushId) {
  const res = await httpService.delete(`kiddush/${kiddushId}`);
  return res;
}

async function keepParasha() {
  const parasha = await httpService.get("parasha");
  return parasha;
}

async function keepInfHome() {
  const user = await httpService.get("user/keepinfhome");
  return user;
}

async function keepMaftir() {
  const maftir = await httpService.get("maftir");
  return maftir;
}

async function addMaftir(data) {
  const maftir = await httpService.post("maftir", data);
  return maftir;
}
async function sendMaftir(data) {
  const maftir = await httpService.post("maftir", data);
  return maftir;
}
async function updateMaftir(data) {
  const maftir = await httpService.put(`maftir/${data._id}`, data);
  return maftir;
}

async function removeMaftir(maftirId) {
  await httpService.delete(`maftir/${maftirId}`);
}
async function keepMaftirH() {
  const maftirH = await httpService.get("maftirH");
  return maftirH;
}

async function sendMaftirH(data) {
  const maftirH = await httpService.post("maftirH", data);
  return maftirH;
}

async function updateMaftirH(data) {
  const maftirH = await httpService.put(`maftirH/${data._id}`, data);
  return maftirH;
}

async function removeMaftirH(maftirHId) {
  const res = await httpService.delete(`maftirH/${maftirHId}`);
  return res;
}
async function sendParasha(data) {
  const parasha = await httpService.post("parasha", data);
  return parasha;
}

async function updateParasha(data) {
  const parasha = await httpService.put(`parasha/${data._id}`, data);
  return parasha;
}

async function removeParasha(parashaId) {
  const res = await httpService.delete(`parasha/${parashaId}`);
  return res;
}
async function keepParashaH() {
  const parashaH = await httpService.get("parashaH");
  return parashaH;
}

async function sendParashaH(data) {
  const parashaH = await httpService.post("parashaH", data);
  return parashaH;
}

async function updateParashaH(data) {
  const parashaH = await httpService.put(`parashaH/${data._id}`, data);
  return parashaH;
}

async function removeParashaH(parashaHId) {
  const res = await httpService.delete(`parashaH/${parashaHId}`);
  return res;
}
async function keepEvennement() {
  const evennements = await httpService.get("evennement");
  return evennements;
}

async function sendEvennement(data) {
  const evennement = await httpService.post("evennement", data);
  return evennement;
}

async function updateEvennement(data) {
  const evennement = await httpService.put(`evennement/${data._id}`, data);
  return evennement;
}

async function removeEvennement(evennementId) {
  const res = await httpService.delete(`evennement/${evennementId}`);
  return res;
}
async function keepDecaissement(filterBy = {}) {
  let queryStr = "?";
  for (const key in filterBy) {
    queryStr += `${key}=${filterBy[key]}&`;
  }
  const decaissements = await httpService.get(`decaissement${queryStr || ""}`);
  return decaissements;
}

async function sendDecaissement(data) {
  const decaissement = await httpService.post("decaissement", data);
  return decaissement;
}

async function updateDecaissement(data) {
  const decaissement = await httpService.put(`decaissement/${data._id}`, data);
  return decaissement;
}

async function removeDecaissement(decaissementId) {
  const res = await httpService.delete(`decaissement/${decaissementId}`);
  return res;
}

async function changePassword(userCred) {
  const rep = await httpService.post("auth/changepassword", userCred);
  //console.log("reponse =", rep);
  return rep;
}
async function signup(userCred) {
  // console.log(userCred);
  const user = await httpService.post("auth/signup", userCred);
  return _handleLogin(user);
}

async function logout() {
  await httpService.post("auth/logout");
  //console.log("cc");
  cookie.remove("jwt", { expires: 1 });
  sessionStorage.clear();
  // window.location.assign("/#/");
}

function _handleLogin(user) {
  // console.log(user);
  sessionStorage.setItem("user", JSON.stringify(user));
  return user;
}
